import React, { Component } from 'react';
import './top.css';
//import Bars from './top/bars.js';
//import Network from './top/network.js';
import Battery from './top/battery.js';
import Clock from './top/Clock';

class Top extends Component {

  render() {
    //const time = new Date().toLocaleString('en-US', { hour: 'numeric', minute:'numeric', hour12: true });
    return (
      <div className="top">
        <div className="top-left">
          {/* {time.replace("AM","").replace("PM","")} */}
          <Clock />
        </div>
        <div className="top-right">
          {/* CELL */}
          <div style={{ display: 'inline-block', height: '20px', width: '20px', color: 'white', marginLeft: '8px', marginRight: '9px', position: 'relative', top: '5px' }}><svg style={{ fill: 'white' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M 25 7 C 15.609375 7 7.070313 10.730469 0.78125 16.769531 L 0.0585938 17.464844 L 5.59375 23.234375 L 6.320313 22.539063 C 11.175781 17.875 17.75 15 25 15 C 32.25 15 38.824219 17.875 43.683594 22.539063 L 44.40625 23.234375 L 49.941406 17.464844 L 49.21875 16.769531 C 42.929688 10.730469 34.390625 7 25 7 Z M 25 9 C 33.5 9 41.191406 12.292969 47.046875 17.589844 L 44.28125 20.46875 C 39.148438 15.867188 32.417969 13 25 13 C 17.582031 13 10.851563 15.867188 5.71875 20.46875 L 2.953125 17.589844 C 8.808594 12.292969 16.5 9 25 9 Z M 25 19 C 18.832031 19 13.214844 21.453125 9.085938 25.421875 L 8.363281 26.113281 L 13.921875 31.90625 L 14.640625 31.210938 C 17.34375 28.613281 20.972656 27 25 27 C 29.027344 27 32.65625 28.613281 35.359375 31.210938 L 36.078125 31.90625 L 41.636719 26.113281 L 40.917969 25.421875 C 36.785156 21.453125 31.167969 19 25 19 Z M 25 21 C 30.28125 21 35.054688 23.011719 38.746094 26.238281 L 35.957031 29.140625 C 32.996094 26.605469 29.199219 25 25 25 C 20.800781 25 17.003906 26.605469 14.042969 29.140625 L 11.253906 26.238281 C 14.945313 23.011719 19.71875 21 25 21 Z M 25 31 C 22.050781 31 19.367188 32.175781 17.390625 34.074219 L 16.671875 34.765625 L 25 43.441406 L 25.71875 42.691406 L 33.328125 34.765625 L 32.609375 34.074219 C 30.632813 32.175781 27.949219 31 25 31 Z M 25 33 C 27.054688 33 28.859375 33.796875 30.375 34.957031 L 25 40.558594 L 19.625 34.957031 C 21.140625 33.796875 22.945313 33 25 33 Z"></path></svg>
          </div>

         <Battery />
        </div>
        <div className="top-center">
          chriscarey.com
        </div>
        {/* iPhone in React */}
      </div>
    );
  }
}

export default Top;
